import { routes } from "@constants/routes";
import {
  EducationForm,
  EducationTable,
  useGetEducationInfoByIdLazyQuery,
  useGetEducationsQuery,
  useResumeStore,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export type TEducationState = "TABLE" | "FORM";

interface IEducationTabContent {
  handleNextTab: () => void;
}

const EducationTabContent = ({ handleNextTab }: IEducationTabContent) => {
  const [educationState, setEducationState] = useState<TEducationState>("TABLE");
  const location = useLocation();
  const { setEducationEditId } = useResumeStore();
  const { data, refetch, loading } = useGetEducationsQuery();
  const [getEducationInfoById, { data: educationInfoByIdData, loading: educationInfoByIdLoading }] =
    useGetEducationInfoByIdLazyQuery();
  useEffect(() => {
    setEducationEditId(undefined);
  }, [setEducationEditId]);

  return (
    <div>
      {educationState === "TABLE" ? (
        <EducationTable
          setEducationState={setEducationState}
          educationState={educationState}
          handleNextTab={handleNextTab}
          data={data?.me?.educations || []}
          loading={loading}
          refetch={refetch}
          showAddNewSection={true}
        />
      ) : (
        <EducationForm
          setEducationState={setEducationState}
          supportUrl={routes.support.main}
          pathname={location.pathname}
          getEducationInfoById={getEducationInfoById}
          educationInfo={educationInfoByIdData?.education?.get}
          getEducationInfoLoading={educationInfoByIdLoading}
          userType={UserTypeEnum.USER}
        />
      )}
    </div>
  );
};

export default EducationTabContent;
